import { getCanvasSize } from "../utils/canvasSize";
import { getCoverScale } from "../utils/getCoverScale";
import { drawCanvas } from "../utils/drawCanvas";

export function useImageUpload({
  canvasRef,
  grid,
  setImg,
  setOriginalFile,
  setFileName,
  setScale,
  setOffset,
}) {
  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    setOriginalFile(file);

    const image = new Image();
    image.src = URL.createObjectURL(file);

    image.onload = () => {
      setImg(image);

      const canvas = canvasRef.current;
      const size = getCanvasSize(grid);

      canvas.width = size.width;
      canvas.height = size.height;

      const initialScale = getCoverScale(image, canvas);

      const initialOffset = {
        x: (canvas.width - image.width * initialScale) / 2,
        y: (canvas.height - image.height * initialScale) / 2,
      };

      setScale(initialScale);
      setOffset(initialOffset);

      drawCanvas({
        canvas,
        image,
        scale: initialScale,
        offset: initialOffset,
        grid,
      });
    };
  };

  return { handleUpload };
}